// frontend/admin-portal/src/components/orders/OrderStatusBadge.jsx
import React from "react";
import { Badge } from "@fiberhome/shared-ui";

const VARIANTS = {
  draft: "default",
  offer_sent: "primary",
  accepted: "success",
  rejected: "danger",
  expired: "default",
  fulfilled: "success",
  cancelled: "danger",
};

const LABELS = {
  draft: "Draft",
  offer_sent: "Offer sent",
  accepted: "Accepted",
  rejected: "Rejected",
  expired: "Expired",
  fulfilled: "Fulfilled",
  cancelled: "Cancelled",
};

export default function OrderStatusBadge({ status }) {
  return (
    <Badge variant={VARIANTS[status] || "default"}>
      {LABELS[status] || status}
    </Badge>
  );
}
